import {
    Crown,
    ShieldCheck,
    Briefcase,
    GraduationCap,
    Star,
    Eye,
    Compass,
    BookOpen,
    Gavel,
    Users,
    Headset,
    FlaskConical,
} from "lucide-react";

export const DISCORD_URL = "https://discord.gg/gz96fyqWs";
export const ROBLOX_URL = "https://www.roblox.com/share/g/739371919";

export const RANK_COLORS = {
    "Rank Pátria": "#EF4444",
    "Rank Fundador": "#F59E0B",
    "Rank Shelby": "#8B5CF6",
    "Rank Supremo": "#3B82F6",
    "Rank Ômega": "#06B6D4",
    "Rank Sentinela": "#10B981",
    "Rank Imperador": "#EC4899",
    "Rank Mega-Developer": "#6366F1",
    "Rank Alpha": "#14B8A6",
    "Rank Diretor-Helper": "#A855F7",
    "Rank Helper": "#3B82F6",
    "Rank Teste-Helper": "#64748B",
};

export const CATEGORIES = [
    "Gerência",
    "Direção",
    "Supervisão",
    "Coordenação",
    "Moderação",
    "Suporte",
];

export const CARGOS = [
    {
        slug: "staff-manager",
        nome: "Staff Manager",
        icon: Crown,
        categoria: "Gerência",
        funcao: "Possui como função gerenciar toda a equipe, mantendo a ordem e organização.",
        quota: { type: "fixed", value: 1, label: "1 Membro" },
        rank: "Rank Pátria",
    },
    {
        slug: "gerente-geral",
        nome: "Gerente Geral",
        icon: ShieldCheck,
        categoria: "Gerência",
        funcao: "Possui como função auxiliar diretamente o Staff Manager atuando como um “02” da equipe, supervisionando os Gerentes e garantindo que toda a equipe esteja cumprindo corretamente suas funções.",
        quota: { type: "fixed", value: 1, label: "1 Membro" },
        rank: "Rank Fundador",
    },
    {
        slug: "gerente",
        nome: "Gerente",
        icon: Briefcase,
        categoria: "Gerência",
        funcao: "Possui como função auxiliar o Gerente Geral, administrar a equipe e acompanhar o desempenho dos Staffs, mantendo a organização e corrigindo possíveis problemas.",
        quota: { type: "fixed", value: 2, label: "2 Membros" },
        rank: "Rank Shelby",
    },
    {
        slug: "aluno-gerencia",
        nome: "Aluno de Gerência",
        icon: GraduationCap,
        categoria: "Gerência",
        funcao: "Possui como função auxiliar os Gerentes em suas funções, aprendendo sobre a administração da equipe e demonstrando capacidade para futuramente assumir o cargo de Gerente.",
        quota: {
            type: "variable",
            label: "Variável",
            sublabel: "Depende do efetivo de gerência",
        },
        rank: "Rank Supremo",
    },
    {
        slug: "diretor",
        nome: "Diretor",
        icon: Star,
        categoria: "Direção",
        funcao: "Possui como função auxiliar diretamente o Aluno de Gerência e os cargos superiores, supervisionando os Supervisores e demais membros da Staff, garantindo o cumprimento das normas, metas e organização da equipe.",
        quota: { type: "fixed", value: 3, label: "3 Membros" },
        rank: "Rank Ômega",
    },
    {
        slug: "supervisor",
        nome: "Supervisor",
        icon: Eye,
        categoria: "Supervisão",
        funcao: "Possui como função auxiliar os superiores e estar supervisionando diariamente o serviço de todos os Staffs, relatando erros, acertos, etc.",
        quota: { type: "fixed", value: 3, label: "3 Membros" },
        rank: "Rank Sentinela",
    },
    {
        slug: "coordenador",
        nome: "Coordenador",
        icon: Compass,
        categoria: "Coordenação",
        funcao: "Possui como função organizar a equipe, tirando todas as dúvidas e corrigindo erros que acontecerem.",
        quota: { type: "fixed", value: 3, label: "3 Membros" },
        rank: "Rank Imperador",
    },
    {
        slug: "aluno-coordenacao",
        nome: "Aluno de Coordenação",
        icon: BookOpen,
        categoria: "Coordenação",
        funcao: "Possui como função auxiliar os Coordenadores, acompanhando a organização da equipe, tirando dúvidas básicas e aprendendo as responsabilidades do cargo de Coordenador.",
        quota: {
            type: "variable",
            label: "Variável",
            sublabel: "Depende do efetivo de coordenação",
        },
        rank: "Rank Mega-Developer",
    },
    {
        slug: "moderador",
        nome: "Moderador",
        icon: Gavel,
        categoria: "Moderação",
        funcao: "Possui como função estar moderando tanto o servidor como o jogo, mantendo um ambiente limpo, organizado e saudável.",
        quota: { type: "fixed", value: 5, label: "5 Membros" },
        rank: "Rank Alpha",
    },
    {
        slug: "diretor-helper",
        nome: "Diretor Helper",
        icon: Users,
        categoria: "Suporte",
        funcao: "Possui como função estar ensinando todos os Helper’s e Teste Helper’s a realizarem suas funções.",
        quota: { type: "fixed", value: 6, label: "6 Membros" },
        rank: "Rank Diretor-Helper",
    },
    {
        slug: "helper",
        nome: "Helper",
        icon: Headset,
        categoria: "Suporte",
        funcao: "Possui como função realizar atendimentos de suporte e estar ativos no jogo movimentando-o realizando treinamentos, recrutamentos, mega-treinos, etc.",
        quota: { type: "unlimited", label: "Ilimitado" },
        rank: "Rank Helper",
    },
    {
        slug: "teste-helper",
        nome: "Teste Helper",
        icon: FlaskConical,
        categoria: "Suporte",
        funcao: "Possui como função realizar estudos aqui dentro da Escola para ficarem aptos a atenderem tickets. Além disso, devem estar ativos no jogo diariamente, movimentando o jogo com recrutamentos e treinamentos.",
        quota: { type: "unlimited", label: "Ilimitado" },
        rank: "Rank Teste-Helper",
    },
];

export const REGRAS_STAFF = [
    {
        numero: 1,
        titulo: "Respeito",
        texto: "Respeite todos os membros e Staffs, independente de cargo ou patente.",
    },
    {
        numero: 2,
        titulo: "Abuso de Poder",
        texto: "É proibido abusar de comandos, permissões ou benefícios concedidos pela Staff.",
    },
    {
        numero: 3,
        titulo: "Hierarquia",
        texto: "Respeite a hierarquia da Staff e as decisões dos superiores.",
    },
    {
        numero: 4,
        titulo: "Atividade",
        texto: "Mantenha-se ativo e cumpra corretamente as funções e metas do seu cargo.",
    },
    {
        numero: 5,
        titulo: "Atendimento",
        texto: "Atenda os membros com educação, paciência e profissionalismo, lembrando que é proibido atender dois tickets ao mesmo tempo!",
    },
    {
        numero: 6,
        titulo: "Punições",
        texto: "Nenhuma punição deve ser aplicada sem motivo ou sem seguir as regras do servidor.",
    },
    {
        numero: 7,
        titulo: "Informações Internas",
        texto: "É extremamente proibido divulgar informações internas da Staff, decisões ou assuntos privados para membros.",
    },
    {
        numero: 8,
        titulo: "Consequências",
        texto: "O descumprimento das regras poderá resultar em advertência, rebaixamento ou remoção da Staff, dependendo da gravidade da situação.",
    },
];

export const REGRAS_PAGO = [
    {
        numero: 1,
        titulo: "Limite de Advertências",
        texto: "Todo Staff pago estará sujeito ao limite máximo de 5 advertências. Ao receber a quinta advertência, o Staff será automaticamente removido da equipe, independentemente do valor investido no cargo, do tempo de permanência na equipe ou de sua posição hierárquica. As advertências serão aplicadas de acordo com a gravidade das atitudes e infrações cometidas.",
    },
    {
        numero: 2,
        titulo: "Respeito e Postura",
        texto: "Todo Staff pago deve manter uma postura respeitosa, profissional e responsável dentro do servidor. É obrigatório tratar membros, colegas de equipe e superiores com educação, sendo proibidas provocações, ofensas, discussões desnecessárias, arrogância ou qualquer comportamento que prejudique o ambiente da comunidade.",
    },
    {
        numero: 3,
        titulo: "Igualdade Perante as Regras",
        texto: "O fato de o cargo ser pago não concede privilégios ou imunidade às regras da equipe. Todos os Staffs pagos possuem as mesmas obrigações e devem seguir integralmente as orientações determinadas pela Administração. O pagamento do cargo não garante permanência na equipe em caso de infrações, má conduta ou acúmulo de advertências.",
    },
    {
        numero: 4,
        titulo: "Representação de Gangs Externas",
        texto: "Staff pago que fizer parte de uma gang que não pertença aos donos do servidor não poderá utilizar sua posição de Staff para atender tickets, prestar suporte ou realizar atendimentos relacionados à equipe enquanto estiver representando essa gang. Caso seja identificado realizando esse tipo de atividade, receberá 1 advertência.",
    },
    {
        numero: 5,
        titulo: "Uso das Permissões",
        texto: "As permissões concedidas ao Staff pago devem ser utilizadas exclusivamente para o exercício de suas funções dentro da equipe. É proibido utilizar o cargo para beneficiar amigos, membros de sua gang ou qualquer grupo externo. Tentativas de obter vantagens, favorecer terceiros ou utilizar a posição de Staff de forma indevida poderão resultar em advertência e, conforme a gravidade ou reincidência, em outras medidas administrativas.",
    },
];

export const RANKS_NOTE =
    "Esta tabela tem como objetivo apresentar a organização dos Ranks da Staff e facilitar o entendimento da hierarquia interna, cargo não é apenas posição, é responsabilidade. Quanto maior o rank, maior deve ser o comprometimento com a equipe e com o servidor.";

export const ESCOLA_ANNOUNCEMENT =
    "A partir de agora, todos os Staffs estão convidados a adentrar à Escola Preparatória de Staff's, um espaço criado para preparar, orientar e aprimorar a equipe. Durante a Escola Staff, serão passadas orientações, regras, procedimentos e ensinamentos importantes para que todos saibam exatamente como agir em suas funções. A participação é importante para todos os Staffs, principalmente para aqueles que desejam evoluir dentro da equipe e demonstrar responsabilidade, comprometimento e maturidade.";

export const ESCOLA_NOTE =
    "Após pedir pra entrar, marque um staff para lhe aceitar!";
